import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SYM = { INR: "₹", USD: "$" };
const LOCALE = { INR: "en-IN", USD: "en-US" };
export const money = (n, cur = "INR") => `${SYM[cur]}${Number(n || 0).toLocaleString(LOCALE[cur])}`;
export const inr = (n) => money(n, "INR");
export const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
export const priceOf = (p, cycle, cur) => p[`price_${cycle}${cur === "USD" ? "_usd" : ""}`];

export function usePlan() {
  const [plan, setPlan] = useState(null);
  const load = () => api.get("/subscription/me").then((r) => setPlan(r.data)).catch(() => setPlan({ error: true }));
  useEffect(() => { load(); }, []);
  return { plan, limits: plan?.limits || null, reload: load };
}

export const yearlySaving = (p, cur = "INR") => {
  const m = priceOf(p, "monthly", cur);
  return m ? Math.max(0, Math.round((1 - priceOf(p, "yearly", cur) / (m * 12)) * 100)) : 0;
};

export const quotaLeft = (plan, key) => {
  const cap = plan?.limits?.[key === "ai" ? "ai_requests" : key];
  return cap == null ? Infinity : cap - (plan.usage?.[key] || 0);
};
